/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_Locale_SelectInputs */



/**
* | output |
* | --- |
* | "Output Locale Select" |
*
* @param {Output_Locale_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const output_locale_select = /** @type {((inputs?: Output_Locale_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_Locale_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection de la locale de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabegebietsschema auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione locale di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор локали вывода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de configuración regional de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出区域选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力ロケールの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट लोकेल चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de localidade de saída")
	return /** @type {LocalizedString} */ ("Output Locale Select")
});